module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.8369/images/sales-meetings-calendar/sales-meetings-calendar.png"